import React, { FunctionComponent } from "react";
import { ImageDataLike } from "gatsby-plugin-image";
import { IContentfulImage } from "../../types/IContentfulImage";
import { Heading } from "../Heading";
import "./style.scss";
import { GatsbyImageOrSvg } from "../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

interface IProps {
  image: IContentfulImage & ImageDataLike;
  title: string;
  headingType?: string;
  body: {
    body: string;
  };
  hasTitleBelowBody: boolean;
  theme?: "light" | "dark";
}

const ImageWithTitleAndText: FunctionComponent<IProps> = ({
  image,
  title,
  body,
  hasTitleBelowBody,
  theme = "light",
  headingType,
}) => (
  <div className={`image-with-title-and-text ${theme}`}>
    <GatsbyImageOrSvg image={image} loading="lazy" alt={image.title} />
    {!hasTitleBelowBody && (
      <Heading className="title" type={headingType || "h3"}>
        {title}
      </Heading>
    )}
    <p className="body">{body.body}</p>
    {hasTitleBelowBody && (
      <Heading className="title" type={headingType || "h3"}>
        {title}
      </Heading>
    )}
  </div>
);

export { ImageWithTitleAndText, IProps };
